<template>
	<view class="fun_list_item" @click="toShopDetails">
		<view class="fun_list_item_img">
			<image src="@/static/uni.png" mode="heightFix"></image>
		</view>
		<view class="fun_list_item_info">
			<view class="fun_list_item_info_top">
				<text>飞盘之后，新中产又被围炉煮茶割韭菜？飞盘之后，新中产又</text>
			</view>
			<view class="fun_list_item_info_bottom">
				<view class="fun_list_item_info_bottom_left">
					<image src="@/static/logo.png" mode="widthFix"></image>
					<text>林之秋</text>
				</view>
				<view class="fun_list_item_info_bottom_right">
					<image src="@/static/icon/home_ic_shoucang@2x.png" mode="widthFix"></image>
					<text>389</text>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			toShopDetails() {
				this.$emit('jump', '12345')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fun_list_item {
		width: 332rpx;
		height: 580rpx;
		border-radius: 20rpx;
		background-color: white;
		overflow: hidden;
		margin-bottom: 36rpx;
		.fun_list_item_img {
			width: 100%;
			height: 420rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			image {
				height: 100%;
			}
		}
		.fun_list_item_info {
			width: 100%;
			padding: 16rpx 12rpx 24rpx 12rpx;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			.fun_list_item_info_top {
				width: 100%;
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
			}
			.fun_list_item_info_bottom {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 15rpx;
				.fun_list_item_info_bottom_left {
					width: 200rpx;
					display: flex;
					align-items: center;
					image {
						width: 32rpx;
						height: 32rpx;
						border-radius: 50%;
						margin-right: 6rpx;
					}
					text {
						width: 100%;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
				.fun_list_item_info_bottom_right {
					display: flex;
					align-items: center;
					image {
						width: 24rpx;
						height: 24rpx;
						margin-right: 6rpx;
					}
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
	}
</style>